import { Box, Typography } from "@mui/material";
import { color, Grid } from "@mui/system";
import LandingLayout from "components/landing/LandingLayout";
import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <LandingLayout>
      <Box sx={{ padding: "6.25vw 19.375vw" }}>
        <Typography
          fontWeight={800}
          sx={{ fontSize: "60px", lineHeight: "72px", textAlign: "center" }}
        >
          Privacy Policy
        </Typography>
        <Typography
          fontWeight={400}
          sx={{ fontSize: "20px", lineHeight: "30px", textAlign: "center" }}
        >
          Updated: 29 Sep, 2025
        </Typography>
        <Typography
          fontWeight={400}
          sx={{ fontSize: "17px", lineHeight: "30px", marginTop: "3rem" }}
        >
          EZIFIN Pty Ltd (“EZIFIN”, “we”, “our”, or “us”) respects your privacy
          and is committed to protecting your personal information. This Privacy
          Policy explains how we collect, use, disclose, and safeguard your
          information when you use our website, platform, and related services.
        </Typography>
        <h1>Privacy Policy</h1>
        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <h3>1.1 Personal Information</h3>
        <ul>
          <li>
            Full name, date of birth, and contact details (email, phone number,
            address).
          </li>
          <li>
            Identification details (e.g. driver’s licence, passport, or other
            government-issued ID).
          </li>
          <li>
            Financial details (bank account information, income, credit history,
            and security offered for loans).
          </li>
          <li>
            Business details (ABN/ACN, financial reports, company ownership, and
            related records).
          </li>
        </ul>

        <h3>1.2 Non-Personal Information</h3>
        <ul>
          <li>
            Technical information such as IP address, browser type, operating
            system, and device identifiers.
          </li>
          <li>
            Usage data including pages visited, time spent, and interactions
            with our platform.
          </li>
          <li>
            Cookies and similar technologies to improve user experience and
            analytics.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Assess and process loan applications and funding requests.</li>
          <li>
            Verify your identity and comply with Know Your Customer (KYC) and
            Anti-Money Laundering (AML/CTF) obligations.
          </li>
          <li>Communicate with you about products, services, and updates.</li>
          <li>
            Improve our services, website functionality, and customer
            experience.
          </li>
          <li>Meet our legal, regulatory, and compliance requirements.</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>
            Credit reporting bodies and financial institutions to assess your
            eligibility.
          </li>
          <li>
            Professional advisers (accountants, legal representatives, or
            financial consultants).
          </li>
          <li>
            Service providers who support our operations (IT, analytics, payment
            processors, customer service).
          </li>
          <li>
            Regulators, law enforcement agencies, or government bodies where
            required by law.
          </li>
          <li>
            Third parties only with your consent or as permitted under the
            Privacy Act 1988 (Cth).
          </li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>

        <h2>4. Data Storage and Security</h2>
        <p>
          Your data is stored securely on servers located in Australia (or
          approved international locations, where applicable).
        </p>
        <p>
          We use encryption, access controls, and other safeguards to protect
          your data. While we take all reasonable steps to secure information,
          no method of transmission over the Internet is completely secure.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          Under the Australian Privacy Principles (APPs), you have the right to:
        </p>
        <ul>
          <li>Access the personal information we hold about you.</li>
          <li>
            Request corrections if your information is inaccurate or incomplete.
          </li>
          <li>Opt-out of marketing communications at any time.</li>
          <li>Complain if you believe we have breached your privacy rights.</li>
        </ul>
        <p>
          To exercise these rights, contact us at{" "}
          <a href="mailto:info@ezifin.com">info@ezifin.com</a>.
        </p>

        <h2>6. Cookies and Tracking</h2>
        <p>We use cookies and tracking technologies to:</p>
        <ul>
          <li>Enhance site functionality.</li>
          <li>Analyse user behaviour for service improvements.</li>
          <li>Provide tailored content and marketing.</li>
        </ul>
        <p>
          You can disable cookies in your browser settings, though some features
          may not function properly.
        </p>

        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the privacy practices or content of those sites.
        </p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The latest
          version will always be available on our website with the updated date.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          For questions, concerns, or complaints about this Privacy Policy or
          how we handle your information, please contact us:
        </p>
        <p>
          <strong>EZIFIN Financial Pty Ltd</strong>
        </p>
        <p>
          Email: <a href="mailto:info@ezifin.com">info@ezifin.com</a>
        </p>
        <p>Phone: 0456 374 567</p>
        <p>Address: Level 7, 99 York St, Sydney, 2000, Australia</p>
      </Box>
    </LandingLayout>
  );
};

export default PrivacyPolicy;
